
import moment from 'moment'
import {Options, Vue} from 'vue-class-component'
import {getContractsRequest} from "@/services/Contracts";
import FilterBar from "@/components/FilterBar.vue";
import {getFilterRequest, hideLoadingLayer, showLoadingLayer} from "@/services/Globals";

@Options({
	components: { FilterBar },
	watch: {
		objectId() {
			this.getContracts()
		}
	}
})
export default class Contracts extends Vue {
	headline = 'Verträge'
	contracts: any[] = []
	moment: any = moment
	activeTab = 'all'
	search = ""
	filter: any =  {}
	filterArr: any = []
	
	get filteredContracts() {
		return this.filterContracts(this.contracts)
	}
	
	get objectId():any {
		return this.$route.params.id ? this.$route.params.id : null
	}
	
	filterContracts(contracts: any) {
		let ret:any = { new: [], active: [], canceled: [], all: [] }
		if ( contracts.length > 0 ) {
			contracts.map((item: any) => {
				if ( parseInt(item.status) === 1 ) { // offen
					item.class = 'accent'
					item.statusName = 'neu'
					ret.new.push(item)
				} else if ( parseInt(item.status) === 2 ) { // bezahlt
					item.class = 'primary'
					item.statusName = 'aktiv'
					ret.active.push(item)
				} else { // storniert
					item.class = 'secondary'
					item.statusName = 'storniert'
					ret.canceled.push(item)
				}
				ret.all.push(item)
			})
		}
		return ret
	}
	
	onFilter(args: any) {
		this.filter     = args.filter
		this.search     = args.search
		this.filterArr  = args.filterArray
		
		this.getContracts({filter: this.filterArr, search: this.search})
	}
	
	showDetail(contract: any) {
		window.open(contract.targetShow, '', '')
	}
	
	getContracts(args: any = {}) {
		getContractsRequest(args).then((res: any) => {
			if ( res.result ) {
				this.contracts = res.result
			}
			
			hideLoadingLayer()
		})
	}
	
	beforeMount() {
		showLoadingLayer()
		
		getFilterRequest('contracts').then((res: any) => {
			if ( !res.result || !res.result.filter ) return false
			
			this.filter = res.result.filter
		})
		
		this.getContracts()
	}
}
